import React from 'react';
import './SmsConsent.css';

const SmsConsent = () => {
  return (
    <div className="sms-consent-page">
      <div className="consent-container">
        <div className="consent-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_bc8ceeeb-cef6-4722-affe-fc24cf6abd59/artifacts/cdjkfkc8_SOUTHWEST-TRAINING-CENTER-flat-logo-1.png" 
            alt="Southwest Training Center" 
            className="consent-logo"
          />
          <h1>SMS Text Message Terms & Consent</h1>
        </div>

        <div className="consent-content">
          <section className="consent-section">
            <h2>Program Description</h2>
            <p>
              Southwest Training Center ("STC", "we", "us") offers an optional SMS text messaging service 
              to help you stay informed about your permit expirations, qualification deadlines, and important 
              training reminders through our Permit Tracker application.
            </p>
          </section>

          <section className="consent-section">
            <h2>Consent to Receive Messages</h2>
            <p>
              By opting in to SMS notifications during registration or through your account settings, 
              you expressly consent to receive recurring automated text messages from Southwest Training Center 
              at the mobile phone number you provide. These messages may include:
            </p>
            <ul>
              <li>Permit expiration reminders (90 days, 60 days, 30 days before expiration)</li>
              <li>BSIS Firearms qualification window notifications</li>
              <li>Training class reminders</li>
              <li>Account status updates</li>
              <li>Important announcements related to your permits</li>
            </ul>
          </section>

          <section className="consent-section">
            <h2>Message Frequency</h2>
            <p>
              Message frequency varies based on your permit deadlines and qualification schedules. 
              You may receive approximately 2-10 messages per month depending on your active permits.
            </p>
          </section>

          <section className="consent-section">
            <h2>Message and Data Rates</h2>
            <p>
              <strong>Message and data rates may apply.</strong> Please contact your wireless carrier 
              for details about your text messaging plan. Southwest Training Center does not charge 
              for SMS messages, but your carrier's standard messaging rates will apply.
            </p>
          </section>

          <section className="consent-section">
            <h2>How to Opt Out</h2>
            <p>
              You may opt out of receiving SMS text messages at any time by:
            </p>
            <ul>
              <li><strong>Replying STOP</strong> to any message you receive from us</li>
              <li>Updating your notification preferences in your account settings</li>
              <li>Contacting us at <a href="mailto:info@southwesttrainingcenter.org">info@southwesttrainingcenter.org</a></li>
              <li>Calling us at <a href="tel:+13108506896">310-850-6896</a></li>
            </ul>
            <p>
              After opting out, you will receive a confirmation message and will no longer receive 
              SMS notifications. You can opt back in at any time through your account settings.
            </p>
          </section>

          <section className="consent-section">
            <h2>Help</h2>
            <p>
              For help or questions about our SMS program, reply <strong>HELP</strong> to any message 
              or contact us:
            </p>
            <ul>
              <li>Email: <a href="mailto:info@southwesttrainingcenter.org">info@southwesttrainingcenter.org</a></li>
              <li>Phone: <a href="tel:+13108506896">310-850-6896</a></li>
              <li>Address: Southwest Training Center, Los Angeles, CA</li>
            </ul>
          </section>

          <section className="consent-section">
            <h2>Privacy</h2>
            <p>
              Your phone number and personal information will not be shared with third parties for 
              marketing purposes. We only use your phone number to send permit-related notifications 
              that you have opted in to receive. For more information, please review our 
              <a href="/privacy-policy" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
            </p>
          </section>

          <section className="consent-section">
            <h2>Supported Carriers</h2>
            <p>
              Our SMS service supports all major US carriers including AT&T, Verizon, T-Mobile, Sprint, 
              and most regional carriers. Carrier delivery is not guaranteed.
            </p>
          </section>

          <section className="consent-section terms-summary">
            <h2>Summary</h2>
            <div className="terms-box">
              <p><strong>Program:</strong> Southwest Training Center Permit Tracker SMS Notifications</p>
              <p><strong>Message Frequency:</strong> Varies (approximately 2-10/month)</p>
              <p><strong>Message & Data Rates:</strong> May apply</p>
              <p><strong>Opt-Out:</strong> Reply STOP at any time</p>
              <p><strong>Help:</strong> Reply HELP or call 310-850-6896</p>
            </div>
          </section>

          <div className="consent-footer">
            <p>Last Updated: January 2025</p>
            <p>© {new Date().getFullYear()} Southwest Training Center. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsConsent;
